import type { CPBreadcrumbItem } from '@ui/components/types/breadcrumb.types'

export interface InjectCoursesProductWithGroupContextOptions {
  groupName: string
  courseName: string
  linkFinalToProduct: boolean
  onNavigateToGroup: () => void
  onNavigateToProduct: () => void
}

/**
 * Builds **Home → group name → course name** when the user opened a course from community context.
 */
export function injectCoursesProductWithGroupContext(
  items: CPBreadcrumbItem[],
  options: InjectCoursesProductWithGroupContextOptions
): CPBreadcrumbItem[] {
  if (items.length < 1) return items

  const home = items[0]
  const middle: CPBreadcrumbItem = {
    label: options.groupName,
    onClick: options.onNavigateToGroup,
  }
  const last: CPBreadcrumbItem = options.linkFinalToProduct
    ? { label: options.courseName, onClick: options.onNavigateToProduct }
    : { label: options.courseName }

  return [home, middle, last]
}

/**
 * Truncates course trails to **Home → Courses → course name** for product and lesson routes.
 * Drops generic “Course” / “Lesson” registry segments and any deeper crumbs.
 */
export function injectCoursesProductNameAsFinalSegment(
  items: CPBreadcrumbItem[],
  courseName: string,
  options: { linkFinalToProduct: boolean; onNavigateToProduct: () => void }
): CPBreadcrumbItem[] {
  if (items.length < 3) return items
  const base = items.slice(0, 2)
  const last: CPBreadcrumbItem = options.linkFinalToProduct
    ? { label: courseName, onClick: options.onNavigateToProduct }
    : { label: courseName }
  return [...base, last]
}
